import styled from 'styled-components'

import { getPhoneAvatarImage } from '~/utils/onboarding'

export const ImagePhone = styled.div<{ withGrayBorder?: boolean }>`
  background-image: url(${({ withGrayBorder }) => getPhoneAvatarImage(withGrayBorder)});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  object-fit: contain;
  height: 225px;
  width: 100%;
`
